import AppointmentSteps from "../AppointmentSteps";
import DefaultSteps from "../DefaultSteps";
import { ConversationStep, Theme } from "../../interfaces";

import { getApplicantSteps } from "../ApplicantSteps";
import EscalationSteps from "../EscalationSteps";

const BookingSteps = (theme: Theme) => {
  if (theme.customFlowData) {
    let mainFlow = theme.customFlowData.flow;
    if (theme.customFlowData.importedFlows) {
      const importedFlows = theme.customFlowData?.importedFlows.map(
        (data: any) => data.flow
      );
      let combinedImportedFlows: any = [];
      importedFlows.forEach((data: any) =>
        data.forEach((_data: any) => combinedImportedFlows.push(_data))
      );
      mainFlow = [...mainFlow, ...combinedImportedFlows];
    }
    return [
      ...mainFlow,
      ...AppointmentSteps(theme),
      ...DefaultSteps(theme),
      ...getApplicantSteps(1),
    ] as ConversationStep[];
  }
  return [
    {
      id: "1",
      type: "bot",
      message: "Hey! 👋",
      trigger: (values: any) => {
        //TODO: This is a coreco specific update. To be remove once custom flows are implemented.

        if (
          values?.theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341" ||
          values?.theme?.apiKey === "546d6807-a0f0-45ef-8bf9-adfc7077b187"
        ) {
          return "coreco-greeting";
        }

        //TODO: END OF LINE

        if (values?.theme?.version === "short") {
          return "3";
        }

        return "2";
      },
    },
    {
      id: "2",
      type: "bot",
      message: `My name is <strong>${theme?.customization?.botName}</strong> - I'm an AI Assistant.`,
      trigger: "how_can_we_help",
      //trigger: "talk_with_advisor",
    },
    //TODO: This is a coreco specific update. To be remove once custom flows are implemented.
    {
      id: "coreco-greeting",
      type: "bot",
      message: `My name is <strong>${theme?.customization?.botName}</strong> - I'm the Coreco AI Assistant.`,
      trigger: "coreco-extra-greeting",
    },
    {
      id: "coreco-extra-greeting",
      type: "bot",
      message:
        "My job is to ask you a few questions and connect you with a member of the team.",
      trigger: "applicant1_firstName",
    },
    //TODO: END OF LINE
    ...getApplicantSteps(1),
    ...AppointmentSteps(theme),
    ...DefaultSteps(theme),
    ...EscalationSteps,
  ] as ConversationStep[];
};

export default BookingSteps;
